function applyMasks() {
    $(".dateMask").not('.isMasked').inputmask({ alias: "datetime", placeholder: "MM/DD/YYYY", inputFormat: "mm/dd/yyyy", insertMode: false, showMaskOnHover: true }).addClass('isMasked');

    $(".timeMask").not('.isMasked').inputmask({ alias: "datetime", placeholder: "HH:MM xm", inputFormat: "hh:MM tt", insertMode: false, showMaskOnHover: true, hourFormat: 12 }).addClass('isMasked');

    $(".phoneMask").not('.isMasked').inputmask("(999) 999-9999").addClass('isMasked');

    $(".hoursMask").not('.isMasked').inputmask({ alias: "decimal", digits: 2, max: 999.99 }).addClass('isMasked');

    $(".decimalMask").not('.isMasked').inputmask({ alias: "decimal", digits: 2 }).addClass('isMasked');

    $(".numberMask").not('.isMasked').inputmask("integer").addClass('isMasked');

    $(".positiveSmallIntegerMask").not('.isMasked').inputmask({ mask: "9", repeat: 3, greedy: false }).addClass('isMasked');

    $(".volunteerHoursMask").not('.isMasked').inputmask({ alias: "decimal", digits: 2, max: 99999.99 }).addClass('isMasked');
}

$(function () {
    applyMasks();
});